import React from 'react'
import schema from "./formSchema"
import uiSchema from "./uiFormSchema"
import JSONSchemaForm from '@rjsf/material-ui'
import {
  Box,
  Button,
  CircularProgress,
  Container,
  createStyles,
  IconButton,
  LinearProgress, makeStyles,
  Typography
} from '@material-ui/core'
import request, { gql } from 'graphql-request'
import BooleanButtonsWidget from './widgets/BooleanButtonsWidget'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Alert from '@material-ui/lab/Alert'
import { Outro } from './Outro'

const sendDataMutation = gql`
    mutation SubmitForm($value: JSONObject!, $ref: String!) {
        submitForm(value: $value, ref: $ref)
    }
`

const pause = async (time) => new Promise((resolve) => setTimeout(resolve, time))

const widgets = {
  CheckboxWidget: BooleanButtonsWidget,
}

function validate(formData, errors) {
  return errors;
}

function transformErrors(errors) {
  return errors.map(error => {
    if (error.name === "pattern") {
      error.message = "Zadejte prosím číslo"
    }
    if (error.name === "required") {
      error.message = "Prosím odpovězte"
    }
    if (error.name === "minimum" && error.params.limit === 0) {
      error.message = "Musí být kladné číslo nebo 0"
    }
    if (error.name === "format" && error.params.format === "email") {
      error.message = "Zadejte prosím platnou emailovou adresu"
    }
    return error
  })
}

const useStyles = makeStyles((theme) =>
  createStyles({
    wrapper: {
      margin: theme.spacing(1),
      position: 'relative',
    },
    buttonProgress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  }),
);

export const AppForm = () => {
  const formRef = React.useRef()
  const classes = useStyles();
  const [ step, setStep ] = React.useState(0)
  const [ lastStep, setLastStep ] = React.useState(schema.length - 1)
  const [ captureType, setCaptureType ] = React.useState(null)
  const [ formData, setFormData ] = React.useState({})
  const [ submitting, setSubmitting ] = React.useState(false)
  const [ error, setError ] = React.useState(null)
  const [ completed, setCompleted ] = React.useState(false)

  const onSubmit = async ({ formData: stepFormData }) => {
    let updatedFormData = {
      ...formData,
      ...stepFormData
    }
    setFormData(updatedFormData)

    if (stepFormData['positivePcrTest']) {
      if (stepFormData['positivePcrTest'] === 'no') {
        setCaptureType('none')
        setCompleted(true)
      } else if (stepFormData['positivePcrTest'] === 'yes-less-than-14-days-ago' || stepFormData['positivePcrTest'] === 'yes-antigen-less-than-14-days-ago') {
        setCaptureType('prospective')
        setLastStep(schema.findIndex(step => step.captureMark === 'end-of-prospective-capture'))
      } else {
        setCaptureType('retrospective')
      }
    }

    if (step < lastStep) {
      setStep(step + 1)
    } else {
      let i = 1;
      while (true) {
        try {
          setError(null)
          setSubmitting(true)
          await request(process.env.REACT_APP_GRAPHQL_URL, sendDataMutation, {
            ref: 'longcovid',
            value: updatedFormData
          })
          setSubmitting(false)
          setCompleted(true)
          break
        } catch (error) {
          if (i++ >= 3) {
            setSubmitting(false)
            setError('Omlouváme se, nastala chyba při odesílání dotazníku, opakujte prosím později.')
            break
          }
          await pause(3000)
        }
      }
    }
  }

  const prevPage = () => {
    if (step > 0) {
      setStep(step - 1)
    }
  }

  if (completed) {
    return <Outro captureType={captureType}/>
  }

  return (
    <Container maxWidth="sm">
      {step > 1 ?
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton onClick={() => prevPage()} disabled={step < 1} aria-label="back">
              <ArrowBackIcon/>
            </IconButton>
            <Box flexGrow={1} textAlign="center">
              <Typography variant="h5">Otázka {step + 1}</Typography>
            </Box>
          </Box>
          <LinearProgress variant="determinate" value={step / lastStep * 100} style={{ marginBottom: '1.5em' }}/>
        </>
        : null}
      {error && <Alert severity="error" style={{ margin: '2em 0' }}>{error}</Alert>}
      <JSONSchemaForm
        id='json-schema-form'
        schema={schema[step]}
        uiSchema={uiSchema}
        onSubmit={onSubmit}
        widgets={widgets}
        formData={formData}
        ref={formRef}
        validate={validate}
        transformErrors={transformErrors}
        showErrorList={false}
        noHtml5Validate
        formContext={{ formRef }}
      >
        <div className={classes.wrapper}>
          <Button type="submit" variant="contained" color="primary" disabled={submitting}>
            {step === 0 ? 'Začít' : step < lastStep ? 'Pokračovat' : 'Odeslat dotazník'}
          </Button>
          {submitting && <CircularProgress size={24} className={classes.buttonProgress}/>}
        </div>
      </JSONSchemaForm>
    </Container>
  )
}
